import React, { useEffect, useState } from 'react';
import {
  Container,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import '../assets/css/App.css'; // Optional for custom styling
import logo from "../assets/images/logoh.png";
import { useTranslation } from 'react-i18next';
import { FaBalanceScale, FaBarcode, FaBars, FaBook, FaBox, FaBoxes, FaBusinessTime, FaBuysellads, FaCalculator, FaCalendar, FaCaravan, FaCashRegister, FaChartArea, FaChartBar, FaChartLine, FaChartPie, FaChevronDown, FaCog, FaCreditCard, FaDirections, FaDollarSign, FaExchangeAlt, FaFileAlt, FaFileContract, FaFileInvoice, FaFileInvoiceDollar, FaHandHoldingUsd, FaHistory, FaIdeal, FaJediOrder, FaList, FaListAlt, FaMoneyBillWave, FaMoneyCheck, FaMoneyCheckAlt, FaReceipt, FaScrewdriver, FaShoppingBasket, FaShoppingCart, FaTachometerAlt, FaTruck, FaTruckLoading, FaTruckMoving, FaTruckPickup, FaUndoAlt, FaUserCheck, FaUserCircle, FaUserCog, FaWarehouse, FaWeight } from 'react-icons/fa';
import { FaUser, FaSignOutAlt } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { authActions } from '../sagas/authSlice';
import { BARCODE_PAGE, BL_PAGE, DEVIS_PAGE, INVOICE_PAGE, INVENTORY_PAGE, REFUND_PAGE, PRODUCTS_PAGE, SALES_PAGE, STOCK_PAGE, DASHBOARD_PAGE, PROFILE_PAGE, PAIMENT_PAGE, COMMANDE_PAGE, PURCHASE_ORDERS_PAGE, PURCHASE_RETURN_PAGE, PURCHASE_PAGE, CUSTOMER_PAYMENTS_PAGE, SUPPLIER_PAYMENTS_PAGE, EXPENSES_PAGE, RECEPTION_PAGE, SUPPLIER_INVOICE_PAGE, SUPPLIER_PAGE, CLIENT_PAGE, CATEGORY_PAGE, ENTREPOT_PAGE, UM_PAGE, DELIVERY_NOTE_PAGE, TRANSPORTEUR_PAGE, JOURNAL_PAGE, GENERAL_LEDGER_PAGE, BALANCE_SHEET_PAGE, TRIAL_BALANCE_PAGE, TAXES_PAGE, CASH_FLOW_PAGE, CHECK_MANAGEMENT_PAGE, BANK_RECONCILIATION_PAGE, BUDGET_PAGE, CUSTOMER_PAGE, SALES_REPORT_PAGE, REGLEMENTS_PAGE, REGLEMENTS_REPORT_PAGE, LOT_PAGE, MOUVEMENT_STOCK_PAGE, CAISSE_PAGE, REPORT_NOTE_PAGE } from '../routes/routeConstants';
import ReglementNotifications from '../components/Reglement/ReglementNotifications';
import { ROLE_ADMIN, ROLE_AGENT, ROLE_CAISSIER } from '../helpers/constants';

const Layout = ({ children }) => {
  const { fullName, businessName } = useSelector(state => state.auth);
  const role = useSelector((state) => state.auth.role);
  const [navbarOpen, setNavbarOpen] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const isCaissier = role === ROLE_CAISSIER;
  const isAdmin = role === ROLE_ADMIN;
  const isAgent = role === ROLE_AGENT;

  const toggleNavbar = () => setNavbarOpen(!navbarOpen);

  const handleLogout = () => {
    Swal.fire({
      title: t('auth.logoutConfirmTitle'),
      text: t('auth.logoutConfirmText'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: t('common.confirm'),
      cancelButtonText: t('common.cancel')
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(authActions.logout());
        Swal.fire({
          icon: 'success',
          title: t('auth.logoutSuccess'),
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          navigate('/login');
        });
      }
    });
  };

  const handleNavigation = (path) => {
    navigate(path);
    setNavbarOpen(false); // Close mobile menu after navigation
  };

  const menuGroups = isAdmin ? [
    {
      id: 'dashboard',
      path: DASHBOARD_PAGE,
      icon: FaTachometerAlt,
      label: t('nav.dashboard'),
      single: true
    },
    {
      id: 'inventory',
      label: t('nav.articles'),
      icon: FaBoxes,
      items: [
        { path: ENTREPOT_PAGE, icon: FaWarehouse, label: t('nav.entrepots') },
        { path: CATEGORY_PAGE, icon: FaBox, label: t('nav.categories') },
        { path: PRODUCTS_PAGE, icon: FaListAlt, label: t('nav.articles') },
        { path: UM_PAGE, icon: FaBalanceScale, label: t('nav.unites') },
        { path: STOCK_PAGE, icon: FaBoxes, label: t('nav.stock') },
      ]
    },
    {
      id: 'sales',
      label: t('nav.salesGroup'),
      icon: FaShoppingCart,
      items: [
        { path: SALES_PAGE, icon: FaCashRegister, label: t('nav.sales') },
        { path: DELIVERY_NOTE_PAGE, icon: FaTruck, label: t('nav.livraison') },
        { path: CLIENT_PAGE, icon: FaUserCircle, label: t('nav.clients') },
        { path: REFUND_PAGE, icon: FaUndoAlt, label: t('nav.returns', 'Retours') },
      ]
    },
  ] : isCaissier ? [
    {
      id: 'inventory',
      path: PRODUCTS_PAGE,
      icon: FaBoxes,
      label: t('nav.articles'),
      single: true
    },
    {
      id: 'commande',
      label: t('nav.commande'),
      icon: FaShoppingCart,
      path: SALES_PAGE,
      single: true
    },
    {
      id: 'caisse',
      label: t('nav.caisse'),
      icon: FaCashRegister,
      path: "/caisse",
      single: true
    },

    {
      id: 'client',
      label: t('nav.client'),
      icon: FaUser,
      path: CLIENT_PAGE,
      single: true
    },

    {
      id: 'history',
      label: t('nav.history'),
      icon: FaHistory,
      path: DELIVERY_NOTE_PAGE,
      single: true
    },
    {
      id: 'retours',
      path: REFUND_PAGE,
      icon: FaUndoAlt,
      label: t('nav.returns', 'Retours'),
      single: true
    },
    {
      id: 'report',
      label: t('nav.report'),
      icon: FaCalculator,
      path: REPORT_NOTE_PAGE,
      single: true
    },
  ]
    :
    [
      {
        id: 'inventory',
        path: PRODUCTS_PAGE,
        icon: FaBoxes,
        label: t('nav.articles'),
        single: true
      },
      {
        id: 'commande',
        label: t('nav.commande'),
        icon: FaShoppingCart,
        path: SALES_PAGE,
        single: true
      },
      {
        id: 'client',
        label: t('nav.client'),
        icon: FaUser,
        path: CLIENT_PAGE,
        single: true
      },
      {
        id: 'retours',
        path: REFUND_PAGE,
        icon: FaUndoAlt,
        label: t('nav.returns', 'Retours'),
        single: true
      },
      {
        id: 'history',
        label: t('nav.history'),
        icon: FaHistory,
        path: DELIVERY_NOTE_PAGE,
        single: true
      },
      {
        id: 'report',
        label: t('nav.report'),
        icon: FaCalculator,
        path: REPORT_NOTE_PAGE,
        single: true
      },
    ];

  return (
    <div className="app-wrapper d-flex flex-column min-vh-100">
      {/* Top Navigation Bar */}
      <Navbar
        color="white"
        light
        expand="lg"
        className="navbar-custom border-bottom shadow-sm px-4"
        style={{ zIndex: 1030 }}
      >
        <NavbarBrand href="#" className="d-flex align-items-center me-4">
          <img
            src={logo}
            alt="MatjarPos"
            height="40"
            className="brand-logo me-2"
          />
          <span className="fw-bold text-primary d-none d-md-block">{businessName}</span>
        </NavbarBrand>

        <NavbarToggler onClick={toggleNavbar} className="border-0">
          <FaBars />
        </NavbarToggler>

        <Collapse isOpen={navbarOpen} navbar className="justify-content-between">
          {/* Main Navigation Menu */}
          <Nav className="me-auto" navbar>
            {menuGroups.map((group) => (
              <div key={group.id}>
                {group.single ? (
                  // Single menu item
                  <NavItem className="me-2">
                    <NavLink
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleNavigation(group.path);
                      }}
                      className={`nav-link-custom d-flex align-items-center px-3 py-2 rounded ${location.pathname === group.path ? 'active' : ''
                        }`}
                    >
                      <group.icon size={16} className="me-2" />
                      <span>{group.label}</span>
                    </NavLink>
                  </NavItem>
                ) : (
                  // Dropdown menu group
                  <UncontrolledDropdown nav inNavbar className="me-2" key={group.id}>
                    <DropdownToggle
                      nav
                      caret
                      className={`nav-link-custom d-flex align-items-center px-3 py-2 rounded ${group.items.some(item => location.pathname === item.path) ? 'active' : ''
                        }`}
                    >
                      <group.icon size={16} className="me-2" />
                      <span>{group.label}</span>
                    </DropdownToggle>
                    <DropdownMenu className="shadow border-0 dropdown-menu-custom">
                      {group.items.map((item) => (
                        <DropdownItem
                          key={item.path}
                          onClick={() => handleNavigation(item.path)}
                          className={`dropdown-item-custom d-flex align-items-center py-2 px-3 ${location.pathname === item.path ? 'active' : ''
                            }`}
                        >
                          <item.icon size={14} className="me-2 text-muted" />
                          <span>{item.label}</span>
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                )}
              </div>
            ))}
          </Nav>

          {/* User Menu */}
          <Nav navbar>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav className="d-flex align-items-center text-dark user-dropdown">
                <div className="d-flex align-items-center">
                  <div className="user-avatar me-2">
                    <FaUserCircle size={24} className="text-primary" />
                  </div>
                  <div className="d-none d-lg-block me-2">
                    <div className="user-name">{fullName}</div>
                    <small className="text-muted user-role">
                      {role === ROLE_ADMIN ? t('role.admin') :
                        role === ROLE_CAISSIER ? t('role.caissier') : t('role.agent')}
                    </small>
                  </div>
                  <FaChevronDown size={12} className="ms-1" />
                </div>
              </DropdownToggle>
              <DropdownMenu end className="shadow border-0 dropdown-menu-custom">
                <DropdownItem header className="py-3">
                  <div className="text-center">
                    <FaUserCircle size={32} className="text-primary mb-2" />
                    <div className="fw-bold">{fullName}</div>
                    <small className="text-muted">
                      {role === ROLE_ADMIN ? t('role.admin') :
                        role === ROLE_CAISSIER ? t('role.caissier') : t('role.agent')}
                    </small>
                  </div>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem
                  onClick={() => navigate('/profile')}
                  className="dropdown-item-custom d-flex align-items-center py-2"
                >
                  <FaUser className="me-2 text-muted" size={14} />
                  {t('user.profile')}
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem
                  onClick={handleLogout}
                  className="dropdown-item-custom d-flex align-items-center py-2 text-danger"
                >
                  <FaSignOutAlt className="me-2" size={14} />
                  {t('user.signOut')}
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Collapse>
      </Navbar>

      {/* Main Content - Full Width */}
      <div className="flex-grow-1">
        <main className="main-content bg-light h-100">
          <Container fluid className="p-4 h-100">
            {children}
          </Container>
        </main>
      </div>

      {/* Footer */}
      <footer className="footer bg-white border-top py-3">
        <Container fluid className="px-4">
          <Row className="align-items-center">
            <Col md={6} className="text-start">
              <span className="text-muted">MatjarPos v1.0</span>
            </Col>
            <Col md={6} className="text-end">
              <span className="text-muted">© {new Date().getFullYear()} IDERACLOUD. All rights reserved.</span>
            </Col>
          </Row>
        </Container>
      </footer>
    </div>
  );
};

export default Layout;
